import { useClearOnUnmount, useFieldHelpers } from '@/base'
import { FormField, FormFieldProps } from '.'
import { Slider, SliderProps } from '../../atoms/slider'

export const FormSlider = (
  props: Omit<SliderProps, 'onChange' | 'value'> &
    Omit<FormFieldProps, 'children'> & {
      onChange?: (val: number) => void
      shouldClearOnDismount?: boolean
      wrapperClassName?: string
    }
) => {
  const {
    name,
    label,
    schema,
    message,
    description,
    optionalText,
    onChange,
    shouldClearOnDismount,
    wrapperClassName,
  } = props
  const { field, helpers } = useFieldHelpers({ name, schema })
  useClearOnUnmount(shouldClearOnDismount, helpers.setValue)

  const value = field.value

  return (
    <FormField
      name={name}
      label={label}
      schema={schema}
      message={message}
      description={description}
      optionalText={optionalText}
      className={wrapperClassName}
    >
      <Slider
        {...props}
        {...field}
        // Slider takes values as an array but this component only maintains one value
        value={value ? [value] : undefined}
        onBlur={() => helpers.setTouched(true)}
        onValueChange={(val) => {
          onChange?.(val[0])
          return helpers.setValue(val[0])
        }}
      />
    </FormField>
  )
}
